namespace $ {

	export class $mol_promise_blocker<Result> extends $mol_promise<Result> {
		static [Symbol.toStringTag] = '$mol_promise_blocker'
	}

}
